import { authService } from '@/services/auth.service'

/**
 * Affiche les permissions de l'utilisateur connecté dans la console
 */
export function displayCurrentUserPermissions() {
  const user = authService.getCurrentUser()
  
  if (!user) {
    console.log('❌ Aucun utilisateur connecté')
    return
  }

  console.log('👤 Utilisateur connecté :')
  console.log(`   Nom: ${user.nom} ${user.prenom}`)
  console.log(`   Email: ${user.email}`)
  console.log(`   Rôle: ${user.role}`)
  console.log(`   Type: ${user.userType}`)
  console.log(`   Organisation: ${user.organizationId || 'Non définie'}`)
  
  const permissions = user.permissions || []
  
  if (permissions.length === 0) {
    console.log('❌ Aucune permission trouvée')
    return
  }

  console.log(`\n🔐 Permissions (${permissions.length} total) :`)
  
  // Grouper par module
  const permissionsByModule: Record<string, string[]> = {}
  permissions.forEach(permission => {
    const [module, action] = permission.split(':')
    if (!permissionsByModule[module]) {
      permissionsByModule[module] = []
    }
    permissionsByModule[module].push(action)
  })

  // Afficher par module
  Object.entries(permissionsByModule).forEach(([module, actions]) => {
    console.log(`\n📁 ${module.toUpperCase()}:`)
    actions.forEach(action => {
      console.log(`   ✓ ${action}`)
    })
  })

  // Statistiques
  const uniqueModules = Object.keys(permissionsByModule).length
  const uniqueActions = new Set(permissions.flatMap(p => p.split(':')[1])).size
  
  console.log(`\n📊 Statistiques:`)
  console.log(`   Modules accessibles: ${uniqueModules}`)
  console.log(`   Actions disponibles: ${uniqueActions}`)
  console.log(`   Permissions totales: ${permissions.length}`)

  // Test de permissions spécifiques
  console.log(`\n🧪 Test de permissions spécifiques:`)
  const testPermissions = [
    'user:read',
    'user:create',
    'employee:read',
    'payroll:process',
    'dashboard:view',
    'system:admin'
  ]

  testPermissions.forEach(permission => {
    const hasPermission = authService.hasPermission(permission)
    console.log(`   ${hasPermission ? '✅' : '❌'} ${permission}`)
  })

  return {
    user,
    permissions,
    permissionsByModule,
    stats: {
      total: permissions.length,
      modules: uniqueModules,
      actions: uniqueActions
    }
  }
}

/**
 * Vérifie si l'utilisateur a une permission spécifique
 */
export function checkPermission(permission: string): boolean {
  return authService.hasPermission(permission)
}

/**
 * Vérifie si l'utilisateur a un rôle spécifique
 */
export function checkRole(role: string): boolean {
  return authService.hasRole(role)
}

/**
 * Vérifie si l'utilisateur est d'un type spécifique
 */
export function checkUserType(userType: string): boolean {
  return authService.isUserType(userType)
}

// Exporter pour utilisation dans la console du navigateur
if (typeof window !== 'undefined') {
  (window as any).checkPermissions = displayCurrentUserPermissions
  ;(window as any).hasPermission = checkPermission
  ;(window as any).hasRole = checkRole
  ;(window as any).isUserType = checkUserType
}
